module.exports = __webpack_public_path__ + "static/img/267_TO8_2358.c44c07d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/267_TO8_2358.jpg
// module id = ukeK
// module chunks = 0